import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

export const useSubscriptionLabel = () => {
    const inertiaProps = usePage<ITopolPageProps>();

    const isTeamSubscription = computed(
        () => inertiaProps.props.team?.personal_team === false
    );

    const planName = computed(() => (isTeamSubscription.value ? 'Team' : 'PRO'));

    const subscriptionLabel = computed(() => `${planName.value} subscription`);

    const subscriptionRouteName = computed(() =>
        isTeamSubscription.value
            ? 'billing.team-subscriptions.index'
            : 'billing.pro-subscriptions.index'
    );

    return { planName, subscriptionLabel, subscriptionRouteName };
};
